/* ===========================================
   DONNÉES DES ŒUVRES
   
   Pour ajouter/modifier une œuvre :
   1. Ajoutez un objet dans le tableau correspondant
   2. Remplissez les champs requis
   
   Structure d'une œuvre :
   {
     title: "Nom de l'œuvre",
     image: "URL de l'image",
     meta: { clé: "valeur", ... },
     sens: "Description / signification"
   }
   =========================================== */

export const peintures = [
  {
    title: "Aurore Silencieuse",
    image: "https://images.unsplash.com/photo-1541961017774-22349e4a1262?w=600&h=600&fit=crop",
    meta: {
      année: "2023",
      technique: "Huile sur toile",
      dimensions: "120 × 80 cm"
    },
    sens: "Une méditation sur l'instant fugace où la nuit cède sa place au jour."
  },
  {
    title: "Fragments d'Éternité",
    image: "https://images.unsplash.com/photo-1549887534-1541e9326642?w=600&h=600&fit=crop",
    meta: {
      année: "2022",
      technique: "Acrylique mixte",
      dimensions: "100 × 100 cm"
    },
    sens: "L'œuvre interroge notre rapport au temps qui passe."
  },
  {
    title: "Mélancolie Océanique",
    image: "https://images.unsplash.com/photo-1578301978693-85fa9c0320b9?w=600&h=600&fit=crop",
    meta: {
      année: "2024",
      technique: "Aquarelle",
      dimensions: "60 × 90 cm"
    },
    sens: "Un hommage à l'immensité marine et aux émotions qu'elle suscite."
  }
];

export const musiques = [
  {
    title: "Nocturne en Ré Mineur",
    image: "https://images.unsplash.com/photo-1511379938547-c1f69419868d?w=600&h=600&fit=crop",
    meta: {
      durée: "4:32",
      genre: "Néo-classique",
      instruments: "Piano, Violoncelle"
    },
    sens: "Une pièce introspective qui explore les recoins sombres de l'âme."
  },
  {
    title: "Échos du Vide",
    image: "https://images.unsplash.com/photo-1493225457124-a3eb161ffa5f?w=600&h=600&fit=crop",
    meta: {
      durée: "6:15",
      genre: "Ambient",
      instruments: "Synthétiseurs"
    },
    sens: "Un voyage sonore à travers des paysages abstraits."
  },
  {
    title: "Danse des Ombres",
    image: "https://images.unsplash.com/photo-1507838153414-b4b713384a76?w=600&h=600&fit=crop",
    meta: {
      durée: "3:48",
      genre: "Jazz contemporain",
      instruments: "Saxophone, Contrebasse"
    },
    sens: "Un dialogue entre la lumière et l'obscurité."
  }
];

export const parfums = [
  {
    title: "Brume d'Automne",
    image: "https://images.unsplash.com/photo-1541643600914-78b084683601?w=600&h=600&fit=crop",
    meta: {
      famille: "Boisé ambré",
      notes: "Cèdre, Ambre",
      concentration: "EDP"
    },
    sens: "L'essence d'une forêt au crépuscule d'octobre."
  },
  {
    title: "Soie Blanche",
    image: "https://images.unsplash.com/photo-1588405748880-12d1d2a59f75?w=600&h=600&fit=crop",
    meta: {
      famille: "Floral musqué",
      notes: "Jasmin, Musc blanc",
      concentration: "Extrait"
    },
    sens: "La pureté incarnée dans un flacon."
  },
  {
    title: "Cuir Nomade",
    image: "https://images.unsplash.com/photo-1594035910387-fea47794261f?w=600&h=600&fit=crop",
    meta: {
      famille: "Cuir épicé",
      notes: "Cuir, Safran, Oud",
      concentration: "Parfum"
    },
    sens: "Un voyage olfactif sur les routes de la soie."
  }
];

/* ===========================================
   CONFIGURATION DU SITE
   =========================================== */

export const siteConfig = {
  name: "TALAT",
  heroImage: "https://images.unsplash.com/photo-1518998053901-5348d3961a04?w=1920&h=1080&fit=crop",
  
  // Informations de contact
  contact: {
    email: "contact@talat.studio",
    address: "12 Rue de l'Art, 75003 Paris"
  },
  
  // Réseaux sociaux
  social: [
    { name: "Instagram", url: "#" },
    { name: "Twitter", url: "#" }
  ],
  
  // Texte À propos
  about: "TALAT est un collectif artistique fondé en 2020, réunissant des créateurs passionnés par l'exploration sensorielle à travers la peinture, la musique et le parfum."
};
